<template>
  <div>
    <div class="cover">
      <div class="item">
        <i class="fas fa-spinner fa-spin"></i>
        <h3>載入中請稍候</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Loading"
};
</script>
<style scoped>
.fa-spinner {
  font-size: 50px;
  margin-bottom: 15px;
}
.cover {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  z-index: 1500;
}
</style>